/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BattleFavorite.css';
import ReactEcharts from 'echarts-for-react'



const emotion=[
  '推荐',
  '好感',
  '中立',
  '差评',
  '反感'
]




class BattleFavorite extends React.Component {

  constructor(props){
    super(props)
    this.state={
      active:'wb'
    }
    this.getOption=this.getOption.bind(this)
  }



  getOption=()=>{


    let propsData=this.props.json||[
      {
        name:'腾讯',
        type:'kol账号',
        data:[332,1002,749,809,181]
      },{
        name:'腾讯',
        type:'普通账号',
        data:[1408,3735,4458,4652,0],
        
      },{
        name:'阿里巴巴',
        type:'kol账号',
        data:[64,247,107,97,66]
      },{
        name:'阿里巴巴',
        type:'普通账号',
        data:[178,274,183,177,9],
      }
      
    ]

    let legendArr=[]
    let xAis=[]

    emotion.forEach((j)=>{
       propsData.forEach((i)=>{
            xAis.push(`${j}\n${i.name}`)
        })
    })

    propsData.forEach((i)=>legendArr.push(i.name))


    legendArr=Array.from(new Set(legendArr)).join(' vs ')
    // console.log(propsData,propsData[0],propsData[0].length,propsData.length)
    let colorList=['#ffd70d','#ffe599','#608f9f','#96c9db','#014d67','#509ebf','#56b6a0','#79d2be','#248e76','#3eac93']
    

    const option = {
      title:{
        text:`受众好感图 - ${legendArr}`,
        subtext:'数据来源：数字品牌榜',
        x:'20'
      },
      color:colorList,
      tooltip : {
          trigger: 'axis',
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
      },
      legend: {
          // data:legendArr,
          data:propsData.map((i)=>{
            // console.log(i)
            return {
              name:`${i.name}${i.type}`,
            }
          }),
          right: 10,
          bottom: 10,
          orient: 'vertical',
          
      },
      toolbox: {
        show: true,
        feature: {
            restore: {},
            saveAsImage: {}
        },
        right: 20
    },
  
      grid: {
          left: '3%',
          right: '15%',
          bottom: '3%',
          containLabel: true
      },
      xAxis : [
          {
              type : 'category',
              data :emotion
          }
      ],
      yAxis : [
          {
              type : 'value'
          }
      ],
      series:propsData.map((i)=>{
        // console.log(i.data,i.type)
    
        return {
          data:i.data,
          // data:[i.mua,i.kol], 
          name:`${i.name}${i.type}`,
          type:'bar',
          stack:i.name
        }
      })
    }
    // console.log(option.series)

    return option

  }

  render() {
    return (
    <div className={s.root}>
      
      <ReactEcharts
        option={this.getOption()}
        style={{
        height: '550px',
        width:'100%',
        
        borderRadius: '4px'
        }}
        className={s.charts}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        onChartReady={this.onChartReadyCallback}/>
    </div>
      
    )


   
  }
}

export default withStyles(s)(BattleFavorite);



// WEBPACK FOOTER //
// src/components/BattleFavorite/BattleFavorite.js